<template>
  <div class="log-in">
    <div class="log-in-form">
      <loading-logo ref="loadingLogo"/>

      <form @submit.prevent="signIn">
        <vi-input
          :autofocus="true"
          v-model="logInForm.email"
          label="Email"
          type="text"
          :disabled="isLoading"
          placeholder=""
          @input="onInput"
        />
        <div class="error-msg" v-if="$v.logInForm.email.$dirty && !$v.logInForm.email.required">Email cannot be blank</div>
        <div class="error-msg" v-if="$v.logInForm.email.$dirty && !$v.logInForm.email.email">Email is invalid</div>

        <vi-input
          v-model="logInForm.password"
          label="Password"
          type="password"
          :disabled="isLoading"
          placeholder=""
          @input="onInput"
        />
        <div class="error-msg" v-if="$v.logInForm.password.$dirty && !$v.logInForm.password.required">Password cannot be blank</div>

        <div class="forgot-password-link" @click="forgotPassword">
          Forgot password?
        </div>

        <div :class="{'actions' : true, 'disabled' : isLoading}">
          <vi-recaptcha-button @verify="signIn" label="LOGIN" :disabled="isLoading"/>
        </div>
        <div v-if="logInError" class="error">
          <span class="text-secondary">Email address</span> or <span class="text-secondary">password</span> is invalid!
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import ViInput from '../components/ui/ViInput';
  import ViButton from '../components/ui/ViButton';
  import LoadingLogo from "../components/LoadingLogo";
  import {required, email} from 'vuelidate/lib/validators';
  import VueRecaptcha from 'vue-recaptcha';
  import ViRecaptchaButton from "../components/ui/ViRecaptchaButton";

  export default {
    components: {
      ViRecaptchaButton,
      LoadingLogo,
      ViInput,
      ViButton,
      VueRecaptcha
    },

    data: () => ({
      logInForm: {
        email: null,
        password: null
      },
      logInError: null,
      isLoading: false
    }),

    validations: {
      logInForm: {
        email: {
          required,
          email
        },
        password: {
          required
        }
      }
    },

    methods: {
      signIn(gRecaptcha) {

        this.$v.$touch();
        if (this.$v.$error) {
          return;
        }

        this.setIsLoading(true);
        this.$store
          .dispatch('auth/signIn', {
            email: this.logInForm.email.trim().toLowerCase(),
            password: this.logInForm.password.trim(),
            gRecaptcha: gRecaptcha
          })
          .then(res => {
            this.$router.push('/');
          })
          .catch(err => {
            this.logInError = true;
            this.setIsLoading(false);
          })
      },
      onInput() {
        this.logInError = null
      },
      forgotPassword() {
        this.$router.push({
          name: "ForgotPassword"
        })
      },
      setIsLoading(isLoading) {
        this.isLoading = isLoading;
        this.$refs.loadingLogo.setLoading(isLoading);
      },
    },

    // created() {
    //   window.signIn = this.signIn;
    // }
  }
</script>

<style lang="scss">
  @import "LogIn";
</style>
